/* eslint-disable jira/filename-case */
import { createSelector, type OutputSelector } from 'reselect';
import { asyncValues } from '@jira/polaris__lib-ts-utils/src/async-value.tsx';
import type { State } from '../types.tsx';
import type { DeferredPromise } from '../../common/utils.tsx';

export const getPremiumFlow = (
	state: State,
): {
	modalDismissed?: boolean;
	lastVisit: {
		isPremium?: boolean;
		updated?: boolean;
	};
	promise: DeferredPromise<void>;
} => state.premium;

export const getPremiumFlowResolvedPromise: OutputSelector<
	State,
	Promise<void>,
	(res: {
		modalDismissed?: boolean;
		lastVisit: {
			isPremium?: boolean;
			updated?: boolean;
		};
		promise: DeferredPromise<void>;
	}) => Promise<void>
> = createSelector(getPremiumFlow, (premium) => premium.promise.promise);

export const getPremiumModalDismissed: OutputSelector<
	State,
	| {
			status: 'loading';
	  }
	| {
			status: 'loaded';
			value: boolean;
	  },
	(res: {
		modalDismissed?: boolean;
		lastVisit: {
			isPremium?: boolean;
			updated?: boolean;
		};
		promise: DeferredPromise<void>;
	}) =>
		| {
				status: 'loading';
		  }
		| {
				status: 'loaded';
				value: boolean;
		  }
> = createSelector(getPremiumFlow, (premium) => {
	if (premium.modalDismissed === undefined) {
		return asyncValues.loading();
	}

	return asyncValues.loaded<boolean>(premium.modalDismissed);
});

export const getPremiumLastVisit: OutputSelector<
	State,
	| {
			status: 'loading';
	  }
	| {
			status: 'loaded';
			value: boolean;
	  },
	(res: {
		modalDismissed?: boolean;
		lastVisit: {
			isPremium?: boolean;
			updated?: boolean;
		};
		promise: DeferredPromise<void>;
	}) =>
		| {
				status: 'loading';
		  }
		| {
				status: 'loaded';
				value: boolean;
		  }
> = createSelector(getPremiumFlow, (premium) => {
	if (premium.lastVisit.isPremium === undefined) {
		return asyncValues.loading();
	}

	return asyncValues.loaded<boolean>(premium.lastVisit.isPremium);
});
